module.exports = __webpack_public_path__ + "static/media/daycareHeroImage.1bb2b18e.png";